export default __webpack_public_path__ + "static/media/logout.4b7a3094.svg";